// Shared plan data + price helper — used by the modal (selection UI) and the
// page footer (so the same CheckoutBar reflects the current selection).
export const PLANS = [
  {
    key: 'starter',
    name: 'STARTER',
    monthly: 119,
    minutes: '300',
    tone: 'starter',
    icon: '/svg/starter-icon_new.svg',
    short: '1 language | Free VoIP number | Basic AI analysis',
    features: ['1 language', 'Free VoIP number', 'Basic AI analysis'],
  },
  {
    key: 'scaler',
    name: 'SCALER',
    monthly: 299,
    minutes: '750',
    tone: 'scaler',
    icon: '/svg/scaler-icon_new.svg',
    recommended: true,
    short: 'Multi-lingual | CRM Sync | Sentiment Analysis',
    features: ['Multi-lingual', 'CRM Sync', 'Sentiment Analysis', 'Priority routing'],
  },
  {
    key: 'growth',
    name: 'GROWTH',
    monthly: 599,
    minutes: '1,500',
    tone: 'growth',
    icon: '/svg/growth-icon_icon.svg',
    short: 'Everything in Scaler | Dedicated support',
    features: ['Everything in Scaler', 'Dedicated support', 'Advanced analytics'],
  },
]

export const priceOf = (plan, yearly) =>
  yearly ? Math.round((plan?.monthly || 0) * 0.83) : plan?.monthly || 0

export const findPlan = (key) => PLANS.find((p) => p.key === key) || PLANS[0]
